import React, { Component } from 'react';
import './Uploading.scss';

import Loading from '@/Common/loading/loading'

class Uploading extends Component {
   state = {
       x : "150"
   }
   lerp =(value1, value2, amount) => {
    amount = amount < 0 ? 0 : amount;
    amount = amount > 1 ? 1 : amount;
    return value1 + (value2 - value1) * amount;
}
    render() {
        if(!this.props.open) return null;
        else return (
            <div className="overlay">
                <Loading componentName={this.props.children} reversal></Loading>
            </div>
        );
    }
}

export default Uploading;